export enum DataSource {
  Public = 'Public',
  Surveillance = 'Surveillance',
  dataSource_Surveillance = 'dataSource_Surveillance',
  dataSource_Public = 'dataSource_Public'
}
